// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const CloseIcon = (props?: any) => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="currentColor"><path d="M16 17a1 1 0 01-.71-.29l-8-8a1 1 0 111.42-1.42l8 8a1 1 0 010 1.42A1 1 0 0116 17z"/><path d="M8 17a1 1 0 01-.71-.29 1 1 0 010-1.42l8-8a1 1 0 111.42 1.42l-8 8A1 1 0 018 17z"/></g></svg>'} />;

(CloseIcon as any).displayName = 'CloseIcon';

export default CloseIcon;
